// TODO: We should consider adding a useful library like `react-window` which will allow us to virtualize the list that is being rendered and make sure we don't render too many records at once.
import * as React from "react";
import { API, graphqlOperation } from "aws-amplify";
import { GraphQLSubscription } from "@aws-amplify/api";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useUser } from "../contexts";
dayjs.extend(utc);

const useSubscriber = (query?: string) => {
  const [{ user }] = useUser();

  const [data, setData] = React.useState<unknown>();
  const [subscription, setSubscription] =
    React.useState<any>();

  // handle fetching more data
  React.useEffect(() => {
    if (!query || !user) return;
    const subscriptionResponse = API.graphql<GraphQLSubscription<typeof query>>(
      graphqlOperation(query),
    ).subscribe({
      next: ({ value }) => {
        setData(value.data);
        console.debug({ value });
      },
      error: (error) => console.error(error),
    });
    if (!subscriptionResponse) return;
    setSubscription(subscriptionResponse);
    return () => subscriptionResponse.unsubscribe();
  }, []);

  return { data, subscription };
};

export default useSubscriber;
